<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span v-if="inquiry._id">상품문의 상세</span>
            <span v-else>상품문의 등록</span>
        </console-title>

        <console-body>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="subtitle-2 font-weight-bold">기본정보</v-card-title>
                        <v-card-text>
                            <v-layout align-center>
                                <v-flex xs6>
                                    작성자 : {{ inquiry.writer.name }} ({{ inquiry.writer.username }})
                                </v-flex>
                                <v-flex xs6>
                                    문의일자 : {{ $dayjs(inquiry.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-col>
    
            </v-row>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2 font-weight-bold">문의상품</v-card-title>
                <v-responsive class="px-4 grey lighten-4">
                    <v-layout align-center>
                        <v-flex shrink><v-img :src="inquiry?.product?.thumb" width="96" height="96" contain></v-img></v-flex>
                        <v-flex class="text-start">
                            <div class="mx-2 text-truncate"><b>{{ inquiry?.product?.name || "삭제된 상품" }}</b></div>
                        </v-flex>
                    </v-layout>
                </v-responsive>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2 font-weight-bold">문의내용</v-card-title>
                <v-card-text>
                    <v-textarea v-model="inquiry.content" outlined hide-details readonly />
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2 font-weight-bold">답변</v-card-title>
                <v-card-text>
                    <v-textarea v-model="inquiry.answer" outlined hide-details />
                </v-card-text>
            </v-card>
        </console-body>


        <v-row class="my-4">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        NaverSmarteditor
    },
    data(){
        return {
            inquiry: {
                _id: this.$route.params._inquiry
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.inquiry._id){
                let { inquiry } = await api.console.shop.inquires.get(this.inquiry);
                this.inquiry = inquiry;
            }
        },
        async save(){
            this.inquiry._id ? await api.console.shop.inquires.put(this.inquiry) : await api.console.shop.inquires.post(this.inquiry);
            alert("저장되었습니다");
            this.$router.go(-1);
        }
    }
}
</script>